const defaultState = {
  date: null,
  weeks: [],
  appointments: [],
  fetchingAppointments: false,
  appointmentsFetched: false
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "SET_DATE": {
        return {
          ...state,
          date: action.payload
        }
      }
      case "SET_WEEKS": {
        return {
          ...state,
          weeks: action.payload
        }
      }
      case "APPOINTMENT_FETCH_MONTH":{
        return {
          ...state,
          appointments: [],
          fetchingAppointments: true
        }
      }
      case "APPOINTMENT_FETCH_MONTH_FULFILLED":{
        return {
          ...state,
          fetchingAppointments: false,
          appointmentsFetched: true,
          appointments: action.payload
        }
      }
      case "APPOINTMENT_FETCH_MONTH_REJECTED":{
        return {
          ...state,
          fetchingAppointments: false,
          appointmentsFetched: false
        }
      }
      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/calendarReducer.js